import type { CSSProperties } from 'react'
import type { NoDaArte } from './arte'

/** O ícone da área. O mesmo SVG serve de ícone pequeno, com o traço 2 do Lucide, e
 *  de arte grande no card, onde o CSS afina o traço e redesenha cada filho.
 *
 *  `pathLength="1"` faz cada filho medir uma unidade, seja linha ou círculo, e o
 *  atraso de 70 ms por filho é o que desenha um traço depois do outro. Os dois não
 *  mudam nada enquanto nenhuma animação usa `stroke-dashoffset`. */
export function AreaArte({ nos, size, className, style }: {
  nos: readonly NoDaArte[]
  size?: number
  className?: string
  style?: CSSProperties
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
    >
      {nos.map(([tipo, atributos], i) => {
        const comum = { pathLength: 1, style: { animationDelay: `${i * 70}ms` } }
        return tipo === 'path'
          ? <path key={i} d={atributos.d} {...comum} />
          : <circle key={i} cx={atributos.cx} cy={atributos.cy} r={atributos.r} {...comum} />
      })}
    </svg>
  )
}
